import { NavLink } from "react-router-dom";
import {
  FaWhatsapp,
  FaEnvelope,
  FaInstagram,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaAngleRight,
  FaTiktok 
} from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* Brand / About */}
        <div className="footer-col footer-about">
          <h3>Savi Guide Zanzibar Tours & Beach Safaris</h3>
          <p>
            We are a locally owned tour company specializing in unforgettable Zanzibar holidays, Tanzania safaris, and Mount Kilimanjaro adventures. With trusted local expertise, we ensure every journey is comfortable, seamless, and full of lasting memories.
          </p>

          <div className="footer-socials">
  <a href="https://wa.me/255682837935" aria-label="WhatsApp">
    <FaWhatsapp />
  </a>
  <a href="mailto:muhammedsalum625@gmail.com" aria-label="Email">
    <FaEnvelope />
  </a>
  <a href="https://www.instagram.com/savi_guide_francophone_zanzibr" aria-label="Instagram">
    <FaInstagram />
  </a>
  <a href="https://www.tiktok.com/@zanzibar1privatetour" aria-label="TikTok">
    <FaTiktok />
  </a>
</div>

        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul className="footer-quicklinks">
            <li><FaAngleRight /><NavLink to="/" end>Home</NavLink></li>
            <li><FaAngleRight /><NavLink to="/day-tours">Day Tours</NavLink></li>
            <li><FaAngleRight /><NavLink to="/water-activities">Water Activities</NavLink></li>
            <li><FaAngleRight /><NavLink to="/hotels">Hotels</NavLink></li>
            <li><FaAngleRight /><NavLink to="/transfers">Transfers</NavLink></li>
            <li><FaAngleRight /><NavLink to="/car-rentals">Car Rentals</NavLink></li>
            <li><FaAngleRight /><NavLink to="/contact">Contact</NavLink></li>
          </ul>
        </div>

        {/* Popular Experiences */}
        <div className="footer-col">
          <h4>Popular Experiences</h4>
          <ul className="footer-experiences">
            <li><FaAngleRight /><NavLink to="/day-tours/stone-town">Stone Town City Tour</NavLink></li>
            <li><FaAngleRight /><NavLink to="/day-tours/spice">Zanzibar Spice Tour</NavLink></li>
            <li><FaAngleRight /><NavLink to="/day-tours/safari-blue">Safari Blue Adventure</NavLink></li>
            <li><FaAngleRight /><NavLink to="/day-tours/prison-island">Prison Island</NavLink></li>
            <li><FaAngleRight /><NavLink to="/day-tours/jozani">Jozani Forest</NavLink></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-col footer-contact">
          <h4>Contact Us</h4>
          <p><FaPhoneAlt /> +255 682 837 935</p>
          <p><FaEnvelope /> savijuma5@gmail.com</p>
          <p><FaMapMarkerAlt /> Zanzibar, Tanzania</p>
          <a href="https://wa.me/255682837935" className="footer-cta">Chat on WhatsApp</a>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Savi Guide Zanzibar Tours & Safaris. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
